'use strict';

var focalPoint = require('focal-point-3.0.0');

var appDom = require('./app-dom');

var init = function() {

	if (appDom.promoLayout.find('[data-focal-point]').length) {

		focalPoint({
			resizeThrottle: 250
		});

	}

};

module.exports = {
	init: init
};
